<i18n src="@/locales/components/views/agro_exporter/production/query_container_export/exportation_details.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <a :class="['link', link_color]" @click.prevent="open = true">
    <i v-if="(icon == null)"
      :class="(exportation.exportation_type_id == 0 ? 'fa-solid fa-ship' : 'fa-solid fa-plane-departure')" />
    <i v-else :class="icon"></i><span class="space-icon" />
    <template v-if="display_booking_code">{{ exportation.booking_code }}</template>
  </a>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="open = false">
      <div class="
          flex
          items-end
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block sm:p-0
        ">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
          leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="panel-modal">
            <div class="panel-modal-close">
              <button type="button" class="panel-modal-close" @click="open = false">
                <span class="sr-only">Close</span>
                <i class="h-6 w-6 fa-solid fa-xmark"></i>
              </button>
            </div>

            <div class="panel-header-title">
              <i
                :class="(exportation.exportation_type_id == 0 ? 'fa-solid fa-ship' : 'fa-solid fa-plane-departure')" /><span
                class="space-icon" />{{ exportation.booking_code }}
            </div>

            <div class="panel-modal-body">
              <div class="grid grid-cols-2 gap-x-4 gap-y-8">
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.week") }}
                  </dt>
                  <dd class="content-data">
                    {{ exportation.week }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.status") }}
                  </dt>
                  <dd class="content-data">
                    <exportation-status :status_id="exportation.status_id" />
                  </dd>
                </div>

                <div class="col-span-2">
                  <div class="table-first-container" v-if="exportation.containers.length > 0">
                    <div class="table-second-container">
                      <div class="table-third-container">
                        <table class="table">
                          <thead class="table-header">
                            <tr>
                              <th scope="col" class="table-header-cell">
                                {{ $t("model.container.container_code") }}
                              </th>
                              <th scope="col" class="table-header-cell">
                                {{ $t("model.container.packing_house") }}
                              </th>
                              <th scope="col" class="table-header-cell">
                                {{ $t("model.container.producers") }}
                              </th>
                              <th scope="col" class="table-header-cell">
                                {{ $t("model.container.customer") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody class="table-body">
                            <tr class="table-row" v-for="container in exportation.containers" :key="container.id">
                              <td class="table-cell">
                                {{ container.container_code }}
                              </td>
                              <td class="table-cell">
                                <div v-html="container.packing_house_names.join('<br />')"></div>
                              </td>
                              <td class="table-cell"></td>
                              <td class="table-cell">
                                {{ container.customer?.name }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <alert-warning v-else :warning_data="{
                    title: $t('labels.not_containers'),
                  }" />
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.origin_export") }}
                  </dt>
                  <dd class="content-data">
                    {{ exportation.origin_export?.name }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.destination_export") }}
                  </dt>
                  <dd class="content-data">
                    {{ exportation.destination_export?.name }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.departured_at") }}
                  </dt>
                  <dd class="content-data">
                    {{ dateFormatter(exportation.departured_at) }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.arrived_at") }}
                  </dt>
                  <dd class="content-data">
                    {{ dateFormatter(exportation.arrived_at) }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.shipping_line") }}
                  </dt>
                  <dd class="content-data">
                    {{ exportation.shipping_line?.name }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.ship") }}
                  </dt>
                  <dd class="content-data">
                    {{ exportation.ship }}
                  </dd>
                </div>

              </div>
            </div>

            <div class="panel-modal-footer">
              <button type="button" class="panel-modal-footer-close" @click="open = false">
                Cerrar
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";

import { ref } from "vue";
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "AEProductionQueryContainerExportExportationDetails",
  components: {
    ExportationStatus,
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
  },
  props: ["exportation", "icon", "link_color", "display_booking_code"],
  setup() {
    const open = ref(false);

    return {
      open,
    };
  },
  data() {
    return {
      data_loaded: false,
    };
  }
};
</script>
